<template>
  <v-container :style="{ height: `${height}px` }" class="banner-wrapper" fluid>
    <div class="slider-container">
      <!-- 左側按鈕 -->
      <v-btn @click="prevSlide" class="nav-button left-button" icon>
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <!-- 幻燈片 -->
      <div class="slider-track" :style="sliderStyle">
        <v-col
          v-for="(slide, index) in loopedSlides"
          :key="index"
          cols="12"
          class="slide-item"
        >
          <img :src="slide.image" alt="Banner Image" class="slide-image" />
        </v-col>
      </div>

      <!-- 右側按鈕 -->
      <v-btn @click="nextSlide" class="nav-button right-button" icon>
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>

    <!-- 點點點 -->
    <div class="dots-wrapper">
      <div class="dots">
        <span
          v-for="(slide, index) in slides"
          :key="index"
          :class="{ active: index === currentIndex }"
          @click="goToSlide(index)"
        ></span>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  props: {
    height: {
      type: Number,
      required: true, // 必須傳入高度
    },
  },

  data() {
    return {
      currentIndex: 0,
      slides: [
        { image: "/banner/banner1.png" },
        { image: "/banner/banner2.png" },
        { image: "/banner/banner3.png" },
      ],
      transitioning: false,
    };
  },
  computed: {
    loopedSlides() {
      return [
        ...this.slides.slice(-1), // 最後一張放到開頭
        ...this.slides,
        ...this.slides.slice(0, 1), // 第一張放到結尾
      ];
    },
    sliderStyle() {
      return {
        transform: `translateX(-${(this.currentIndex + 1) * 100}%)`,
        transition: this.transitioning ? "transform 0.5s ease" : "none",
      };
    },
  },
  methods: {
    prevSlide() {
      if (this.transitioning) return;
      this.transitioning = true;
      this.currentIndex--;
      setTimeout(() => {
        if (this.currentIndex < 0) {
          this.currentIndex = this.slides.length - 1;
          this.disableTransition();
        }
        this.enableTransition();
        this.transitioning = false;
      }, 500);
    },
    nextSlide() {
      if (this.transitioning) return;
      this.transitioning = true;
      this.currentIndex++;
      setTimeout(() => {
        if (this.currentIndex >= this.slides.length) {
          this.currentIndex = 0;
          this.disableTransition();
        }
        this.enableTransition();
        this.transitioning = false;
      }, 500);
    },
    goToSlide(index) {
      if (this.transitioning) return;
      this.transitioning = true;
      this.currentIndex = index;
      setTimeout(() => {
        this.transitioning = false;
      }, 500);
    },
    disableTransition() {
      document.querySelector(".slider-track").style.transition = "none";
    },
    enableTransition() {
      document.querySelector(".slider-track").style.transition = "transform 0.5s ease";
    },
  },
};
</script>

<style scoped>
/* 外框設定 */
.banner-wrapper {
  position: relative;
  width: 100%;
  max-width: 800px; /* 固定最大寬度為 800px */
  height: auto; /* 固定高度為 500px */
  margin: 0 auto;
  overflow: hidden;
  background-color: #f5f5f5; /* 圖片未加載時的背景色 */
}

.slider-container {
  height: 100%; /* 高度填滿父元素 */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden; /* 防止超出 */
}

.slide-image {
  width: 100%;
  height: 100%; /* 確保高度填滿容器 */
  object-fit: cover; /* 自動裁切圖片使其適應容器 */
}


.slider-track {
  display: flex;
  transition: transform 0.5s ease;
}

.slide-item {
  flex: 0 0 100%;
  max-width: 100%;
}

.slide-image {
  width: 100%; /* 充滿父容器 */
  height: 100%;
  object-fit: cover; /* 確保圖片完整顯示且不變形 */
  background-color: #f5f5f5; /* 圖片未加載時的背景色 */
}


/* 點點點容器 */
.dots-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.dots {
  display: flex;
}

.dots span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #ccc;
  margin: 0 5px;
  cursor: pointer;
}

.dots span.active {
  background-color: #246531;
}

/* 左右按鈕 */
.nav-button {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #246531;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  cursor: pointer;
  z-index: 1; /* 提高層級，確保按鈕不被其他元素遮擋 */
  display: flex;
  justify-content: center;
  align-items: center; /* 垂直居中 */
}
.nav-button:hover {
  background-color: #d8f3dc; /* 淺綠色 */
}
.left-button {
  left: 10px;
}

.right-button {
  right: 10px;
}

/* RWD 支援 */
@media (max-width: 768px) {
  .banner-wrapper {
    max-width: 100%;
    height: auto;
  }

  .nav-button {
    width: 30px;
    height: 30px;
  }

  .dots span {
    width: 10px;
    height: 10px;
  }
}
</style>
